import UAParser, {type IResult} from 'ua-parser-js';

// user-agent client hints not yet ready; fall back to user-agent string
// https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgentData

const ua =
    typeof window !== 'undefined' ? new UAParser(navigator.userAgent).getResult() : ({} as IResult);

export function getMobilePlatform(): 'iOS' | 'Android' | null {
    //     switch (navigator.userAgentData.platform) {
    //         case 'iOS':
    //         case 'Android':
    //             return platform;
    //         default:
    //             return null;
    //     }

    switch (ua.os.name) {
        case 'iOS':
        case 'Android':
            return ua.os.name;
        default:
            return null;
    }
}

export function isMac() {
    //     return navigator.userAgentData.platform === 'macOS';

    return ua.os.name === 'Mac OS';
}

export function isMobilePlatform(): boolean {
    //     return navigator.userAgentData.mobile;

    return getMobilePlatform() !== null;
}
